import type { ParamMatcher } from "@sveltejs/kit";

export const DASH_URLS = [
  "apps",
  "logs",
  "secrets",
  "storage",
  "images",
  "sandboxes",
  "clusters",
  "endpoints",
  "containers",
  "notebooks",
  "evaluations",
];

// This matcher is used to redirect URLs like `/apps` to `/apps/:workspace/:environment`.
export const match: ParamMatcher = (param) => {
  return DASH_URLS.includes(param);
};

// Keep in sync with is_valid_environment_name in name_utils.py
// https://github.com/modal-labs/modal-client/blob/main/modal/_utils/name_utils.py
// TODO: remove the _ from the first char when we deprecate _internal_playground_dont_use
// Accepts periods so existing environments with periods in their names still route.
export const isValidEnvironmentName = (name: string): boolean => {
  // first char is alnum, the rest allows other chars
  return (
    name.length <= 64 &&
    /^[a-zA-Z0-9_][a-zA-Z0-9-_.]*$/.test(name) &&
    !name.toLowerCase().startsWith("en-")
  );
};

export const isValidNewEnvironmentName = (name: string): boolean =>
  isValidEnvironmentName(name) && !name.includes(".") && !name.startsWith("_");
